import { useMemo } from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "../../../hooks/useParams";
import { SortByFilter, FilterValues } from "./SortByFilter";
import { UserFilter, DateFilter } from "../../../components/Filters/";
import { useGetUsersQuery } from "../../../services/accounts";
import { ResourceTypeFilter } from "./ResourceTypeFilter";
import { ResourceType } from "../../../services/types";
import { LanguageFilter } from "./LanguageFilter";
import { useDateFilterParams } from "../../../hooks/useDateFilterParams";
export const Filters = () => {
  const {
    t
  } = useTranslation();
  const [params, setParams] = useParams();
  const [activeDateFilter, setActiveDateFilter] = useDateFilterParams();
  const {
    data: users
  } = useGetUsersQuery();
  const userOptions = useMemo(() => {
    return users?.map(user => ({
      firstName: user.firstName,
      lastName: user.lastName,
      ZUID: user.ZUID,
      email: user.email
    }));
  }, [users]);
  return <Stack direction="row" gap={1.5} data-sentry-element="Stack" data-sentry-component="Filters" data-sentry-source-file="index.tsx">
      <SortByFilter value={params.get("sort") as FilterValues || "modified"} onChange={value => setParams(value, "sort")} data-sentry-element="SortByFilter" data-sentry-source-file="index.tsx" />
      <ResourceTypeFilter onChange={value => setParams(value, "resource")} value={params.get("resource") as ResourceType || ""} data-sentry-element="ResourceTypeFilter" data-sentry-source-file="index.tsx" />
      <UserFilter value={params.get("user") || ""} onChange={value => setParams(value, "user")} defaultButtonText={t("common.createdBy")} options={userOptions} data-sentry-element="UserFilter" data-sentry-source-file="index.tsx" />
      <DateFilter withDateRange defaultButtonText={t("shell.dateModified")} onChange={value => setActiveDateFilter(value)} value={activeDateFilter} data-sentry-element="DateFilter" data-sentry-source-file="index.tsx" />
      <LanguageFilter value={params.get("lang") || ""} onChange={value => setParams(value, "lang")} data-sentry-element="LanguageFilter" data-sentry-source-file="index.tsx" />
    </Stack>;
};